export const testimonials = [
  {
    name: 'Rita J.',
    postedDate: '2025-03-19',
    ratingNumber: 5,
    avatarUrl: '',
    content: `Honestly, Cartify has completely changed how we source for our restaurant. It’s so much easier now to compare suppliers, track prices, and place orders without the endless WhatsApp back and forth. Highly recommend for anyone in the F&B business.`,
  },
  {
    name: 'Hussein H.',
    postedDate: '2025-03-19',
    ratingNumber: 5,
    avatarUrl: '',
    content: `Was skeptical at first but Cartify turned out to be a game changer. We get better deals and don’t waste time chasing suppliers anymore. The dashboard is clean and super easy to use.`,
  },
  {
    name: 'Jamil A.',
    postedDate: '2025-03-19',
    ratingNumber: 5,
    avatarUrl: '',
    content: `It just works. I can find everything I need for the kitchen, filter by price or availability, and get it all delivered without stress. Love how organized it keeps my orders.`,
  },
  {
    name: 'Anthony S.',
    postedDate: '2025-03-19',
    ratingNumber: 5,
    avatarUrl: '',
    content: `Cartify made our purchasing process so much more efficient. One place for all our suppliers, transparent prices, and no need for back-and-forth calls. This should’ve existed years ago`,
  },
];
